<template>
  <div v-if="notes && notes.length !== 0">
    <div class="content" v-if="notes">
      <div class="notes-label has-text-grey mb-1">Notes</div>
      <div v-for="(group, groupIndex) in noteGroups" :key="groupIndex" class="note-group">
        <div v-if="group.type" class="note-type">{{ group.type }}</div>
        <ul class="notes-list">
          <li v-for="(note, index) in group.notes" :key="index" class="note-item">
            {{ formatNote(note, group.hasAbbreviations) }}
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PayerNotes',
  props: ['notes'],
  computed: {
    noteGroups() {
      const groups = new Map();
      for (const note of this.notes || []) {
        const type = typeof note?.type === 'string' ? note.type.trim() : '';
        const key = type.toLowerCase();
        if (!groups.has(key)) groups.set(key, { type, notes: [], hasAbbreviations: false });
        const group = groups.get(key);
        const text = typeof note === 'string' ? note : note?.message;
        if (typeof text === 'string' && group.notes.some((existing) => {
          const message = typeof existing === 'string' ? existing : existing?.message;
          return typeof message === 'string' && message.trim().toLowerCase() === text.trim().toLowerCase();
        })) continue;
        group.notes.push(note);
        if (typeof text === 'string' && /^BENEFIT ABBREVIATIONS\s*-\s*/i.test(text.trim())) {
          group.hasAbbreviations = true;
        }
      }
      return Array.from(groups.values());
    },
  },
  methods: {
    formatNote(note, hasAbbreviations) {
      const text = typeof note === 'string' ? note : note?.message;
      if (typeof text !== 'string') return '';
      if (!hasAbbreviations || !/^(?:BENEFIT ABBREVIATIONS\s*-\s*)?[A-Z0-9]{2,3}\s*=/i.test(text.trim())) return text;
      const entries = text.trim()
        .replace(/^BENEFIT ABBREVIATIONS\s*-\s*/i, '')
        .split(/,\s*(?=[A-Z0-9]{2,3}\s*=)/i)
        .map((entry) => entry.match(/^([A-Z0-9]{2,3})\s*=\s*([\s\S]*)$/i));
      if (entries.some((entry) => !entry || /^\s*,\s*\S/.test(entry[2]))) return text;
      return entries.map((entry) => entry[2].replace(/,\s*$/, '').trim() || entry[1]).join(', ');
    },
  },
};
</script>

<style scoped>
.notes-label {
  font-size: 0.9rem;
  font-weight: 400;
  line-height: 1.4;
}

.note-group + .note-group {
  margin-top: 0.75rem;
}

.note-type {
  color: #666;
  font-size: 0.9rem;
  font-weight: 600;
  line-height: 1.4;
  text-transform: lowercase;
}

.notes-list {
  list-style: none;
  margin: 0;
  padding: 0.25rem 0 0;
}

.notes-list .note-item {
  color: #666;
  font-size: 0.9rem;
  line-height: 1.4;
  margin-top: 0;
  margin-bottom: 0.4rem;
  padding-left: 1.25rem;
  position: relative;
  text-transform: lowercase;
  white-space: pre-line;
  overflow-wrap: anywhere;
}

.note-item::before {
  content: '•';
  position: absolute;
  left: 0.5rem;
  color: #7957d5;
  font-weight: bold;
}

.note-item:last-child {
  margin-bottom: 0;
}
</style>
